export default __webpack_public_path__ + "static/media/kanryou-form.ece5b813.png";